module.exports = {
      id: "technology-usage",
      viewBox: "0 0 22.958 22.633",
      url: "/" + "sprite-5d017f3fe034ec5d98a70bae909b913a.svg#technology",
      toString: function () {
        return this.url;
      }
    }